import React from 'react';
import data from '../../legal-content/damage-protection.json';
import LegalDocument from '../../components/LegalDocument/LegalDocument';

const TermProtectionPage = () => <LegalDocument data={data} currentPage="TermProtectionPage" />;

export default TermProtectionPage;
